export enum QAReports {
    Carrefour = 1,
    Weborama,
    Afilead,
    CitiServi,
    Fintonic,
    Logan,
    CitiServiMAIDs,
    CitiServiCTVs,
    CitiServiErisPixel,
    CitiServiAfileadWeboramaPixel
}